<template>
  <div class="account-body accountbg" style="background:url(static/images/bg_02.jpg) no-repeat center; background-size: cover">
    <div class="container position-relative" style="z-index: 2">
      <div class="m-auto vh-100 d-flex justify-content-center align-items-center">
        <div style="width: 1000px; box-shadow: 0px 20px 80px 0px rgb(36,94,153);" class="align-self-center">
          <el-row>
            <el-col :span="11">
              <div class="p-5 d-flex justify-content-center align-items-center position-relative" style="height: 447px; background: #333; background:url(static/images/bg_02.jpg) no-repeat center;">
                <div class="text-center">
                  <div class="logo logo-admin overflow-hidden d-block"><el-image src="static/images/logo-sm.png" class="auth-logo" style="width:120px;height: 120px;"></el-image></div>
                  <h4 class="mt-4 font-weight-semibold text-white font-18">珠心算应用权限管理系统</h4>
                </div>
                <h6 class="position-absolute text-white font-12 font-weight-normal" style="bottom:4px">{{$GLOBAL.versionNB}}</h6>
              </div>
            </el-col>
            <el-col :span="13">
              <div class="p-5 bg-white" style="height: 447px;">
                <div class="d-flex justify-content-between align-items-end">
                  <h3 class="m-0">登录</h3>
<!--                  <div>没有帐号？<a href="http://shop.ziskia.com/platform/form.html" target="_blank" class="text-primary">点此注册</a></div>-->
                </div>
                <div class="card-body">
                  <div class="form-group mt-3">
                    <label for="username">账号</label>
                    <div class="input-group mb-3">
                      <input v-model="account" @keyup.enter="submitHandle()" type="text" class="form-control" id="username" placeholder="账号 / 手机号">
                    </div>
                    <label for="username">密码</label>
                    <div class="input-group mb-3">
                      <el-input size="small" class="form-control form-control-el" v-model="password" @keyup.enter="submitHandle()" type="password" id="password" placeholder="请输入您的密码" show-password></el-input>
                    </div>
                  </div>
                  <div class="form-group mb-0 row">
                    <div class="col-12 mt-2">
                      <el-button @click="submitHandle()" size="small" type="primary" :loading="btnLoad[0].value" class="w-100">
                        <span v-if="!btnLoad[0].value">立即登录</span>
                        <span v-else>登录中...</span>
                      </el-button>
                    </div>
                  </div>
                  <div class="m-2 text-center text-muted">已有帐号，忘记密码？</div>
                  <div class="account-social"><h6 class="my-4">其他方式登录</h6></div>
                  <div class="btn-group btn-block invisible">
                    <button type="button" class="btn btn-sm btn-outline-primary">微信扫码</button>
                    <button type="button" class="btn btn-sm btn-outline-secondary">短信验证</button>
                    <button type="button" class="btn btn-sm btn-outline-blue">第三方注册</button>
                  </div>
                </div>
              </div>
            </el-col>
          </el-row>
        </div>
        <verify v-if="is_Verify" ref="verify" :mode="fixed" :imgSize="{width:'330px', height: '155px'}" @success="success"></verify>
<!--        <p class="text-center py-3 position-absolute" style="bottom: 0;color: #ffffff;">© 2021广州致凯网络科技有限公司版权所有 粤ICP备14055977号 增值电信业务经营许可证</p>-->
      </div>
    </div>
  </div>
</template>

<script>
// 拖拽验证
import Verify from '@/components/verifyJs/Verify'

export default {
  name: 'Login',
  components: {
    Verify
  },
  data () {
    return {
      // 默认值
      btnLoad: [{value: false}, {value: false}, {value: false}, {value: false}],
      is_Verify: true,
      fixed: 'pop',
      // 账户信息
      account: '',
      password: ''
    }
  },
  // =*=生命函数钩子=*=
  // created 是在模版渲染成html或者模版编译进路由前调用
  // mounted 是在模版已经渲染成html之后调用
  // =*=[keep-alive]=*=
  // activated, deactivated 这两个生命周期函数一定是要在使用了keep-alive组件后才会有的，否则则不存在
  // 页面第一次进入，钩子的触发顺序created -> mounted -> activated
  // 退出时触发deactivated。当再次进入（前进或者后退）时，只触发activated
  // activated 中的逻辑不管是否需要缓存都会进行执行
  created () {
    // console.log(this.$route)
  },
  mounted () {
    // 获取10位数的时间戳
    // this.timestamp = Math.round(new Date().getTime() / 1000).toString()
    // this.adminInfo = this.storageGet('adminInfo')
    // if (this.adminInfo === null) {
    //   // 重新登录
    //   // console.log('B0')
    // } else {
    //   // 存储时间戳大于当前时间戳
    //   if (this.adminInfo.timestamp > this.timestamp) {
    //     // console.log('B1')
    //     this.$router.push({name: this.GoToMain})
    //   } else {
    //     // 重新登录
    //     // console.log('B2')
    //   }
    // }

    // 定义背景图
    // this.imgBG = this.randomNumBoth(1, 9)

    // 判断是否存在登录信息
    // if (localStorage.hasOwnProperty('adminInfo')) {
    //   // 读取登录用户的信息
    //   this.adminInfo = JSON.parse(localStorage.adminInfo)
    //   // 时间戳的值大于当前时间 就直接用TOKEN进行验证登录
    //   if (this.adminInfo.timestamp > this.dataForm.timestamp) {
    //     // 重新接口获取
    //     this.dataForm.token = this.adminInfo.token
    //     this.AxiosAutoObtain('LoginAdmin', false)
    //     console.log('B1')
    //   } else {
    //     // 将存储的管理员信息给删除
    //     localStorage.removeItem('adminInfo')
    //     console.log('B2')
    //   }
    // }
  },
  activated () {
  },
  // watch 专门负责监听的模块 某些地方有用
  watch: {
    // 监听数据值一旦发生变化就执行
    // routeName () {
    //   console.log(this.$route.name)
    // }
  },
  // methods 所有的方法都应该在这个函数里定义，其他地方调用
  methods: {
    // 功能 - 获取区间值
    // randomNumBoth (Min, Max) {
    //   const Range = Max - Min
    //   const Rand = Math.random()
    //   return Min + Math.round(Rand * Range)
    // },

    // 拖拽验证通过
    success (params) {
      this.btnLoad[0].value = true
      // console.log(params)
      let typeBox = params.captchaVerification.split('---')
      // console.log(typeBox)
      const arrayDataB = JSON.parse(typeBox[1])
      // console.log(arrayDataB)
      // 数据赋值
      this.arrayHandle = {
        account: this.account,
        password: this.password,
        code: arrayDataB
      }
      // 开始执行
      this.$api.login.index(this.arrayHandle).then(res => {
        if (res.code === 0) {
          // 存储token 并 跳转去首页
          // document.cookie = 'Admin-Token=' + res.data.token
          // if (this.$GLOBAL.PowerSwitch && this.$GLOBAL.routePower.length) {
          //   this.$router.push({name: this.$GLOBAL.routePower[0]})
          // } else {
          this.$router.push({name: this.$GLOBAL.loginPath})
          // }
        } else {
          this.is_Verify = false
        }
        this.btnLoad[0].value = false
      }).catch(() => {
        this.btnLoad[0].value = false
      })
    },

    // 点击提交
    submitHandle () {
      this.btnLoad[0].value = true
      // 验证字段填写
      if (this.account === '' || this.password === '') {
        this.btnLoad[0].value = false
        this.$message({type: 'error', customClass: 'messageNew', offset: 11, message: '账号密码必须填写'})
        return false
      }
      this.is_Verify = true
      // 倒计时
      const that_ = this
      let timer = null
      timer = setInterval(function () {
        // 时间完结之后再改回来
        that_.$refs.verify.show()
        that_.btnLoad[0].value = false
        // that_.btnLoad[index].value = false
        clearInterval(timer)
      }, 1000)
    }
  },
  // computed 是计算属性 有需要计算的值放这里
  computed: {
  }
}
</script>

<style scoped>
  .account-body.accountbg{background-size:cover;background-color:#fff;min-height:100vh;height:100%;display:flex;align-items:stretch;justify-content:center}
  .form-control-el{
    height: 100%;
    line-height: 1.7;
  }
  /deep/ .form-control .el-input__inner{
    border: none !important;
    height: 100% !important;
    padding: 0 !important;
  }
</style>



// WEBPACK FOOTER //
// src/pages/Login.vue